import gql from "graphql-tag";

export default {
    get: gql`query RankingCell($id: ID!) {
        rankingCell(id: $id) {
                id,
                background_color,
                text_color,
                border_color,
                size
                display_fields {
                    id,
                    name
                }
            }
        }`,
    
    update: gql`mutation UpdateRankingCell ($input: UpdateRankingCellInput!) {
            updateRankingCell (input: $input) {
                id,
                background_color,
                text_color,
                border_color,
                size,
                display_fields {
                    id,
                    name
                }
            }
        }`,
    updateDisplayFields: gql`mutation updateRankingDisplayFields ($input: UpdateRankingDisplayFieldsInput!) {
            updateRankingDisplayFields (input: $input) {
                id,
                display_fields {
                    id,
                    name
                }
            }
        }`,
    createDisplayField: gql`mutation createRankingDisplayFields ($input: CreateRankingDisplayFieldInput!) {
            createRankingDisplayFields (input: $input) {
                id,
                name,
                cell_id
            }
        }`,
    
    deleteDisplayField: gql`mutation deleteRankingDisplayFields ($id: ID!) {
            deleteRankingDisplayFields (id: $id) {
                id
            }
        }`,
};